/**
 * Design tokens extracted from the existing dashboard CSS and Colours map.
 * Prefer `theme.palette` / `theme.colours` in new MUI (Emotion) code.
 */

export const colours = {
  teal: '#34bebd',
  blue: '#082842',
  red: '#ED1C24',
  lightOrange: '#FEEFDE',
  orange: '#ED941E',
  darkGrey: '#BCBEC0',
  darkTeal: '#0F4561',
  white: '#ffffff',
  lightGray: '#55616b',
  veryLightGray: '#828282',
  hoverOrange: '#ffe7cc',
  hoverGrey: '#F0F0F0',
  lightGrey: '#f2f2f2',
  black: '#000000',
  link: '#41a7f5',
  headerBackground: '#ebf3fd',
  pageGradientEnd: '#e0ecf5',
  scrollbarTrack: '#f5f5f5',
  scrollbarThumb: '#f2f2f2',
  scrollbarThumbBorder: '#b9b9b9',
  highlight: '#34bebd',
} as const

export type Colours = typeof colours

export const fonts = {
  body: "'Lato', sans-serif",
  heading: "'Montserrat', sans-serif",
} as const

export const radii = {
  input: 5,
  button: 10,
  pill: 5,
  scrollbar: 5,
} as const

export const layout = {
  defaultGridSpacing: 4,
} as const

export type Layout = typeof layout

export const scrollbar = {
  width: 10,
  track: colours.scrollbarTrack,
  thumb: colours.scrollbarThumb,
  thumbBorder: colours.scrollbarThumbBorder,
} as const
